module.exports = __webpack_public_path__ + "static/media/logo.f50ec90c.svg";